import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DefaultThunkConfig } from '@/app/providers/storeProvider';
import { cookieHelper, CookieKeyEnum } from '@/app/cookies';
import { rtkApi } from '@/z-shared/api';
import { authActions } from '../slice/authSlice';

export const logoutUser = createAsyncThunk<undefined, void, DefaultThunkConfig>(
    'auth/logout',
    async (_, thunkApi) => {
        const { rejectWithValue, dispatch } = thunkApi;
        cookieHelper.remove(CookieKeyEnum.USER_DATA);

        try {
            dispatch(authActions.logoutUser());
            // сносим кэш, чтобы при перезаходе запросить данные заново
            dispatch(rtkApi.util.resetApiState());
            return;
        }
        catch {
            return rejectWithValue(undefined);
        }
    },
);
